<template>
    <div ref="destinationGroup" class="destinationGroup">
        <div v-for="(group, index) in groups" :key="index" >
            <DestinationList :cruiseType="cruiseType" 
            :ref="`destinationList${index}`"
            :subCategory="subCategory"
            :group="group"
            :destinations="destinations"
            :index="index"
            :groupCount="groups.length"
            :groupDests="getGroupDests (destinations, group, subCategory)"
            :initOpenList="initOpenIndex == index"
            :onDestinationListOpen="onDestinationListOpen"
            />
            <div class="area-country-content-line" v-if="checkDestinationNeedLine(index, groups)"></div>
        </div>
    </div>
</template>

<script>
const DestinationList = () => import('@/components/Home/SearchBar/DestinationList')

export default {
    name: 'DestinationGroupForm',
    components: {
        DestinationList
    },
    props: {
        cruiseType: {
            type: String,
            default: function() {
                return "hp"
            }
        },
        subCategory: {
            type: String,
            default: function() {
                return ""
            }
        },
        groups: {
            type: Array,
            default: function() {
                return []
            }
        },
        destinations: {
            type: Array,
            default: function() {
                return []
            }
        },
        onDestinationListOpen: {
            type: Function
        }
    },
    data () {
        return {
            cruiseNotAllowTips: "<div><img src='https://resource.rcclchina.com.cn/partner/search-bar-tips.png' /></div>",
        }
    },
    methods: {
        checkDestinationNeedLine (j, groups) {
            return j < groups.length - 1
        },
        getGroupDests (destinations, group, subGroup) {
            let groupDests = []
            destinations.forEach((destination) => {
                if (destination.cruiseFilterGroupName == group && destination.cruiseFilterGroupSubCategory == subGroup
                && destination.countryName && destination.countryName.length > 0) {
                    groupDests.push(destination)
                }
            })
            return groupDests
        },
        getDestinationByGroup (desitnationGroup) {
            return this.destinations.filter(item => item.cruiseFilterGroupName == desitnationGroup)
        }
    },
    computed: {
        // 默认展开的目的地列表，取第一个没有全disbale的目的地
        initOpenIndex () {
            let canOpenIndexs = []
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].destinations
            this.groups.forEach((group, index) => {
                let destinationCodes = this.getDestinationByGroup(group).map(item=>item.filterCode)
                let isNotDisbaleAll = availableItems.some(item=> destinationCodes.includes(item))
                if (isNotDisbaleAll) {
                    canOpenIndexs.push(index)
                }
            })
            return canOpenIndexs.length == 0 ? -1:canOpenIndexs[0]
        }
    }
}
</script>
